'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

require('flickity-imagesloaded');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UspsCarousel = function UspsCarousel(el) {
  (0, _classCallCheck3.default)(this, UspsCarousel);

  var carousel = (0, _functional.getElement)('[data-module="header-promo-carousel"]');

  var flkty = new _flickity2.default(carousel, {
    cellAlign: 'left',
    cellSelector: '.hd-BottomBar_Item',
    imagesLoaded: true,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    watchCSS: true,
    autoPlay: 4000,
    touchVerticalScroll: false,
    dragThreshold: 30
  });

  flkty.on('dragStart.el', function (event, pointer) {
    document.ontouchmove = function (e) {
      e.preventDefault();
    };
  });

  flkty.on('dragEnd.flickity', function (event, pointer) {
    document.ontouchmove = function (e) {
      return true;
    };
  });
};

exports.default = UspsCarousel;